import { AnalyticsEvent, AnalyticsEventAttributes } from '@backstage/frontend-plugin-api';

// Must not exceed the backend's limits, otherwise the whole batch is rejected.
const MAX_STRING_LENGTH = 512;
const MAX_ATTRIBUTE_KEY_LENGTH = 64;

export type UsageAnalyticsEvent = {
  action: string;
  subject: string;
  value?: number;
  attributes?: AnalyticsEventAttributes;
  context: {
    pluginId: string;
    extensionId: string;
    routeRef?: string;
    entityRef?: string;
  };
};

const truncate = (value: string) => value.slice(0, MAX_STRING_LENGTH);

function normalizeAttributes(attributes?: AnalyticsEventAttributes) {
  if (!attributes) {
    return undefined;
  }

  const normalized: AnalyticsEventAttributes = {};
  for (const [key, attributeValue] of Object.entries(attributes)) {
    // NaN and Infinity serialize to null, which the backend rejects.
    if (typeof attributeValue === 'number' && !Number.isFinite(attributeValue)) {
      continue;
    }
    normalized[key.slice(0, MAX_ATTRIBUTE_KEY_LENGTH)] =
      typeof attributeValue === 'string' ? truncate(attributeValue) : attributeValue;
  }
  return normalized;
}

export function toUsageAnalyticsEvent({
  action,
  subject,
  value,
  attributes,
  context,
}: AnalyticsEvent): UsageAnalyticsEvent {
  const { pluginId, extensionId, routeRef, entityRef } = context;
  return {
    action: truncate(action),
    subject: truncate(subject),
    value: Number.isFinite(value) ? value : undefined,
    attributes: normalizeAttributes(attributes),
    context: {
      pluginId: truncate(pluginId),
      extensionId: truncate(extensionId),
      routeRef: typeof routeRef === 'string' ? truncate(routeRef) : undefined,
      entityRef: typeof entityRef === 'string' ? truncate(entityRef) : undefined,
    },
  };
}
